import { Route } from '@angular/router';
import { ServicesComponent } from './services.component';
import { servicesSuffixUrlCanMatch } from './services-route.util';
import { servicesUrlNormalizeGuard } from './services-url-normalize.guard';

export const ServicesRoutes: Route = {
  path: '',
  component: ServicesComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: () => 'crop-monitoring',
    },
    {
      path: 'crop-monitoring',
      loadComponent: () => import('./crop-monitoring/crop-monitoring.component').then((m) => m.CropMonitoringComponent),
    },
    {
      path: 'irrigation',
      loadComponent: () => import('./irrigation/irrigation.component').then((m) => m.IrrigationComponent),
    },
    {
      path: 'weather-pest',
      loadComponent: () =>
        import('./weather-soil-pest/weather-soil-pest.component').then((m) => m.WeatherSoilPestComponent),
    },
    {
      path: 'analysis',
      loadComponent: () => import('./analysis/analysis.component').then((m) => m.AnalysisComponent),
    },
    {
      path: 'crop-nutrition',
      loadComponent: () => import('./crop-nutrition/crop-nutrition.component').then((m) => m.CropNutritionComponent),
    },
    {
      path: 'crop-nutrition/add-vra-record',
      loadComponent: () =>
        import('./crop-nutrition/add-vra-record/add-vra-record.component').then((m) => m.AddVraRecordComponent),
    },
    {
      path: 'crop-nutrition/vra-details/:vraRecordId',
      loadComponent: () =>
        import('./crop-nutrition/vra-details/vra-details.component').then((m) => m.VraDetailsComponent),
    },
    {
      path: 'activityLogs',
      loadComponent: () => import('./activity-logs/activity-logs.component').then((m) => m.ActivityLogsComponent),
    },
    {
      path: ':tab/:plantationId',
      canMatch: [servicesSuffixUrlCanMatch],
      canActivate: [servicesUrlNormalizeGuard],
      component: ServicesComponent,
    },
  ],
};
